module.exports = __webpack_public_path__ + "static/media/earth.74db5dc4.svg";